import { BaseModel } from "@/models/base.model"
import { type IPerson } from "@/interfaces/api/person.interface"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"
import { ModelFactory } from "@/factories/model-factory"
import { Address } from "@/models/address.model"

export class Person extends BaseModel implements IPerson {
  public static className = "Person" // Used for socket communication.
  public static verboseName = "persoon"

  public static override managedResolveFields: string[] = ["knownBusinessEntities"]

  id?: string

  knownBusinessEntities: KnownBusinessEntity[]

  address: Address

  firstName: string

  lastName: string

  citizenNumber?: string

  phoneNumber?: string

  constructor(person: IPerson, managed = false) {
    super(person)

    this.id = person.id

    this.knownBusinessEntities = ModelFactory.childModels(
      KnownBusinessEntity,
      person.knownBusinessEntities,
      managed
    )
    this.address = ModelFactory.childModel(Address, person.address, managed)

    this.firstName = person.firstName
    this.lastName = person.lastName
    this.citizenNumber = person.citizenNumber
  }

  public getDisplayText(): string {
    if (this.knownBusinessEntities.length > 0) {
      return (
        this.fullName + " (" + this.knownBusinessEntities.map((kbe) => kbe.name).join(", ") + ")"
      )
    }
    return this.fullName + "(geen bedrijven)"
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }
}
